<template>
  <router-view />
</template>

<script>
import { eventHelper, authHelper } from "@/utils/helpers";

export default {
  name: "App",
  mounted() {
    this.$store.commit("user/updateLoggedInUser", authHelper.user);
    eventHelper.$on("userLoggedOut", () => {
      this.$store.commit("user/updateAuthStatus", authHelper.check());
      this.$store.commit("user/updateLoggedInUser", authHelper.user);
      this.$router.push("/securegate");
    });
    document.addEventListener("keydown", this.keyListener.bind(this));
  },
  methods: {
    keyListener(e) {
      if (e.altKey && e.key === "s") {
        let routeData = this.$router.resolve({ path: "/sales/list" });
        window.open(routeData.href, "_blank");
        // this.$router.push("/sales/list");
      } else if (e.altKey && e.key === "p") {
        let routeData = this.$router.resolve({ path: "/pos" });
        window.open(routeData.href, "_blank");
        // this.$router.push("/sales/list");
      }
    }
  }
};
</script>
<style>
.el-select-dropdown__item.hover {
  background-color: #a2c4f7 !important;
}
.el-autocomplete-suggestion li:hover {
  background-color: #a2c4f7 !important;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  color: #fff;
}
/* .el-autocomplete-suggestion li.highlighted,
.el-autocomplete-suggestion li:hover {
  background-color: #5e72e4 !important;
  color: #fff;
}
.el-select-dropdown__item.hover {
   background-color: #5e72e4 !important;
  /* color: #fff; */
/* color:red */
/* }.el-select-dropdown__item.selected.hover {
   background-color: #5e72e4 !important;
  /* color: #fff; */
/* color:red */
/* }
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover {
  color: #fff;
}  */
</style>
